var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVotingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99956 13.2498H9.49956V17.6248C9.49956 17.7905 9.56541 17.9495 9.68262 18.0667C9.79983 18.1839 9.9588 18.2498 10.1246 18.2498H13.8746C14.0403 18.2498 14.1993 18.1839 14.3165 18.0667C14.4337 17.9495 14.4996 17.7905 14.4996 17.6248V13.2498H16.9996C17.1172 13.2496 17.2325 13.2162 17.332 13.1535C17.4316 13.0907 17.5114 13.0012 17.5624 12.8951C17.6133 12.7891 17.6334 12.6708 17.6202 12.5539C17.607 12.437 17.561 12.3261 17.4877 12.2341L12.4877 5.98413C12.2496 5.68726 11.7496 5.68726 11.5114 5.98413L6.51144 12.2341C6.43809 12.3261 6.39217 12.437 6.37896 12.5539C6.36574 12.6708 6.38577 12.7891 6.43675 12.8951C6.48772 13.0012 6.56756 13.0907 6.66712 13.1535C6.76667 13.2162 6.88189 13.2496 6.99956 13.2498Z",
    fill: "#FCD559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotingIcon);
export default __webpack_public_path__ + "static/media/voting_icon.4925d5afe053e7473322af283ef32eec.svg";
export { ForwardRef as ReactComponent };